import { useEffect } from "react";
import KeycloakService from "../../config/keycloak";
import useAppRoutes from "./useAppRoutes";
import { Navigate, Route, Routes } from "react-router-dom";
import RouteWrapper from "./route-wrapper/RouteWrapper";
import { routePaths } from "../../util/constants";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../store/customers/actions";
import {
  OPERATOR,
  RESOURCE_ACCESS_PORTALE_GA,
} from "../../util/keycloakConstants";
import PageLoader from "../page-loader/PageLoader";

const App = () => {
  const integrationId = useSelector(
    (state) => state.customersReducer.selectedCustomer.integrationId
  );
  const customerId = useSelector(
    (state) => state.customersReducer.nngWsCustomerId.value
  );
  const customerLoading = useSelector(
    (state) => state.customersReducer.nngWsCustomerId.loading
  );
  const pageLoading = useSelector(
    (state) => state.customersReducer.refreshCacheLoading
  );
  const [routes] = useAppRoutes();
  const dispatch = useDispatch();
  const isOperator = KeycloakService.hasResourceRole(
    [OPERATOR],
    RESOURCE_ACCESS_PORTALE_GA
  );

  useEffect(() => {
    const tokenParsed = KeycloakService.getInstance.tokenParsed;

    console.log(KeycloakService.getToken());
    console.log(tokenParsed);
    if (!isOperator) {
      const newCompany = {
        codiceFiscale: "",
        customerCode: tokenParsed.customerCode,
        integrationId: tokenParsed.companyId,
        name: tokenParsed.companyId,
        pIva: "",
      };
      dispatch(actions.setSelectedCompany(newCompany));
    }
    dispatch(
      actions.getCompanyName(isOperator ? integrationId : tokenParsed.companyId)
    );
    dispatch(actions.getNngWsCustomer(integrationId));
  }, [dispatch, integrationId, isOperator]);

  useEffect(() => {
    if (customerId) {
      dispatch(actions.refreshCache(customerId, integrationId, '1'));
    }
  }, [customerId, dispatch, integrationId]);

  return customerId && !pageLoading && !customerLoading ? (
    <Routes>
      {routes.map((r) => (
        <Route
          path={r.path}
          key={r.path}
          element={
            <RouteWrapper
              component={r.component}
              layout={r.layout}
              canSeeRoute={r.canSeeRoute}
              redirectTo={r.redirectTo}
            />
          }
        />
      ))}
      <Route path="*" element={<Navigate to={routePaths.NNG} />} />
    </Routes>
  ) : (
    <PageLoader />
  );
};

export default App;
